import React from 'react';

export function NullChoiceEditor() {
  return null;
}

export default NullChoiceEditor;
